import { useEffect, useState } from 'react';

/**
 * Returns `value` after it has stayed unchanged for `delayMs`. Each change
 * restarts the timer, so only the last value in a burst is emitted. The timer
 * is cleared on change and on unmount.
 *
 * @param {*} value - the fast-changing source value (e.g. an input string)
 * @param {number} delayMs - debounce window in milliseconds (default 300)
 * @returns {*} the debounced value
 */
export const useDebouncedValue = (value, delayMs = 300) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timerId = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timerId);
  }, [value, delayMs]);

  return debounced;
};

export default useDebouncedValue;
